import {
   FaPlusCircle,
   FaUsers,
   FaUserShield,
   FaKey,
} from 'react-icons/fa';

/**
 * Grupo fixo de Configurações.
 * Renderizado sempre no rodapé do menu, independente do módulo ativo.
 * Diferente dos grupos de MODULES_NAV por ter `requiredAny` — usado pra
 * decidir se o grupo inteiro sequer aparece pro usuário (gate de acesso).
 */
const GROUP_CONFIGURACOES = {
   key: 'configuracoes',
   label: 'Configurações',
   icon: FaUserShield,
   requiredAny: [
      'iam:user:read',
      'iam:user:create',
      'iam:role:read',
      'iam:role:create',
      'iam:permission:read',
      'iam:permission:create',
   ],
   children: [
      {
         to: '/users/new',
         label: 'Criar usuário',
         icon: FaPlusCircle,
         permissionAny: ['iam:user:create'],
      },
      {
         to: '/users',
         label: 'Listar usuários',
         icon: FaUsers,
         // Só `read` (2026-09-14, handoff 0110). O RBAC do backend virou por
         // verbo: `create` não implica mais ler a listagem, e deixar a entrada
         // acesa para quem só cria levaria direto ao /403 da rota.
         permissionAny: ['iam:user:read'],
      },
      {
         to: '/roles',
         label: 'Gerenciar roles',
         icon: FaUserShield,
         permissionAny: ['iam:role:read', 'iam:role:create'],
      },
      {
         to: '/permissions',
         label: 'Gerenciar permissões',
         icon: FaKey,
         permissionAny: ['iam:permission:read', 'iam:permission:create'],
      },
   ],
};

export default GROUP_CONFIGURACOES;
